import {addErrorMessage} from "../core/errors/errorSlice";
import {store} from "../app/store";


export default (err: any) => {

    if(err && err.response && err.response.data && err.response.data.message){
        store.dispatch(addErrorMessage({title: err.response.data.message}));
        // dispatch(addErrorMessage({title: 'Errore caricamento della lista dei giorni di chiusura. Riprova più tardi, grazie.'}))
    }
    return Promise.reject(err);
}
